// extracted by mini-css-extract-plugin
export var addButton = "_j9-0";
export var border = "_j9-8";
export var check = "_j9-h";
export var danger = "_j9-6";
export var dropdownContainer = "_j9-1";
export var editModalBody = "_j9-j";
export var footerContainer = "_j9-i";
export var fullWidth = "_j9-a";
export var hide = "_j9-9";
export var icon = "_j9-3";
export var input = "_j9-7";
export var inputFlex = "_j9-b";
export var inputWrapper = "_j9-c";
export var manualFocus = "_j9-5";
export var optionButton = "_j9-4";
export var pillWrapper = "_j9-e";
export var pointer = "_j9-2";
export var showOverflow = "_j9-f";
export var tagsFlex = "_j9-d";
export var xButton = "_j9-g";